import { useStyletron } from 'baseui';
import { ValueDisplayIcon } from '../../components/ValueDisplay'


export function ValuePanelIcon(props: any) {
    const [css, theme] = useStyletron();


    return (
            <ValueDisplayIcon {...props}></ValueDisplayIcon>
    );
}